// src/models/egresoDetModel.js

import pb from '../lib/pocketbase.js';

// Obtener los detalles de egreso paginados
export async function getEgresoDets(egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDet').getList(page, perPage, {
      filter: `egresoCab = "${egresoCabId}"`,
      $autoCancel: false
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.currentPage,
    };
  } catch (error) {
    console.error("Error fetching egresoDet:", error);
    throw new Error("Error al obtener los detalles de egreso");
  }
}

// Crear un nuevo detalle de egreso
export async function createEgresoDet(egresoDet) {
  try {
    const response = await pb.collection('egresoDet').create(egresoDet);
    return response;
  } catch (error) {
    console.error("Error creating egresoDet:", error);
    throw new Error("Error al crear el detalle de egreso");
  }
}

// Actualizar un detalle de egreso
export async function updateEgresoDet(id, egresoDet) {
  try {
    const response = await pb.collection('egresoDet').update(id, egresoDet);
    return response;
  } catch (error) {
    console.error("Error updating egresoDet:", error);
    throw new Error("Error al actualizar el detalle de egreso");
  }
}

// Eliminar un detalle de egreso
export async function deleteEgresoDet(id) {
  try {
    await pb.collection('egresoDet').delete(id);
  } catch (error) {
    console.error("Error deleting egresoDet:", error);
    throw new Error("Error al eliminar el detalle de egreso");
  }
}

// Buscar detalles de egreso por descripción con paginación
export async function searchEgresoDets(query, egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDet').getList(page, perPage, {
      filter: `descrip ~ "${query}" && egresoCabId = "${egresoCabId}"`,
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching egresoDets:", error);
    throw new Error("Error al buscar los detalles de egreso");
  }
}